import React, { useState, useEffect, useRef, useMemo } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import { useCustomController } from "../../../../Reusable/Form/useCustomController.js";
import useOnClickOutside from "../../../../../hooks/useOnClickOutside.js";
import { useUser } from "contexts/userContext/userContext.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
const CustomListField = (props) => {
  const { getTextByKey } = useContent();
  const { getUserData } = useUser();

  const { fieldControls } = useCustomController(props);

  // state handle dropdown
  const [showList, setShowList] = useState(false);

  // state handle current selected country value
  const [inputValue, setInputValue] = useState(fieldControls.value);

  // state handle hidden search within the list
  const [searchString, setSearchString] = useState("");

  // ref to handle reseting of searchString after timeout
  const searchStringTimeoutRef = useRef(false);

  const listRef = useRef(null);

  //Get country value and constKey by name
  const getCountryByName = async () => {
    const response = await apiRequest("Dictionaries", "GetCountryByName");
    if (response.status === "success") {
      setInputValue(response.data?.countryCode);
    }
  };

  useEffect(() => {
    if (getUserData().UserCountry.length > 0) {
      getCountryByName();
    }
  }, [getUserData().UserCountry]);

  // setting searchString
  const handleHiddenSearch = (e) => {
    setSearchString((prev) => prev + e.key);
    clearTimeout(searchStringTimeoutRef.current);
    searchStringTimeoutRef.current = setTimeout(() => {
      setSearchString("");
    }, 1000);
  };

  //handle scroll to relevant country
  const handleScroll = (countryId) => {
    const relevantLi = document.getElementById(countryId);
    if (relevantLi) {
      listRef.current.scrollTop = relevantLi.offsetTop - 10;
    }
  };

  // handle find relevant country by searchString
  const handleSearch = () => {
    const listElem = listRef.current;
    const firstRelevantItemId = props.item.selectList.find((countryObj) =>
      countryObj?.constKey
        ?.toLowerCase()
        .startsWith(searchString.toLocaleLowerCase())
    )?.value;

    if (listElem && firstRelevantItemId) {
      handleScroll(firstRelevantItemId);
    }
  };

  useEffect(() => {
    if (searchString.length > 0) {
      handleSearch();
    }
  }, [searchString]);

  // adding/removing event listeners
  useEffect(() => {
    if (showList) {
      window.addEventListener("keypress", handleHiddenSearch);
      // autoscroll to selected country
      if (inputValue) {
        handleScroll(inputValue);
      }
      return () => {
        window.removeEventListener("keypress", handleHiddenSearch);
      };
    } else {
      clearTimeout(searchStringTimeoutRef.current);
    }
  }, [showList]);

  const ref = useRef();
  useOnClickOutside(ref, () => setShowList(false));

  useEffect(() => {
    if (inputValue) {
      fieldControls.onChange(inputValue);
    }
    props.setSuccess(false);
  }, [inputValue]);

  //func to handle choosing a country from the list, updating input value on this one, and closing the list after
  const chooseCountry = (obj) => {
    setInputValue(obj.value);
    setShowList(false);
  };

  const clickOnArrow = () => {
    setShowList((prev) => !prev);
  };

  const selectedCountryName = props.item.selectList.find(
    (country) => country.value === inputValue
  )?.constKey;

  return (
    <div className="list-container">
      <div className="input-div">
        <label className="select-outside-label">
          {getTextByKey(props.item.label)}
        </label>
        <div className="select-container" ref={ref}>
          <div
            className="select-label"
            onClick={() => clickOnArrow()}
            onChange={handleHiddenSearch}
          >
            {selectedCountryName}
          </div>
          <div
            className={`tootltip-icon-container`}
            onClick={() => clickOnArrow(true)}
          >
            <Icon white medium name="arrow-down" />
          </div>
          {showList && (
            <div className="display-list">
              <ul ref={listRef}>
                {props.item.selectList.map((country) => {
                  return (
                    <li
                      onClick={() => chooseCountry(country)}
                      key={country.value}
                      id={country.value}
                      className={country.value === inputValue ? "selected" : ""}
                    >
                      {country?.constKey}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomListField;
